export default __webpack_public_path__ + "static/media/icon-arrow-top.edbe1574.svg";